<template>
  <div class="customForm">
    <div class="cptTitle">{{currentEle.type+formTitle[eleType]}}配置</div>
    <t-form label-width="100px" v-if="eleType === 0">
      <t-form-item label="布局方式">
        <t-select v-model="currentEle.layout" :disabled="true" size="small">
          <t-option label="自定义" value="custom"/>
          <t-option label="自动" value="auto"/>
          <t-option label="层次布局" value="dagre"/>
          <t-option label="环形布局" value="circular"/>
          <t-option label="网格布局" value="grid"/>
          <t-option label="力导向布局" value="gForce"/>
          <t-option label="辐射型布局" value="radial"/>
        </t-select>
      </t-form-item>
      <t-form-item label="排列方向">
        <t-select v-model="currentEle.rankdir" :disabled="true" size="small">
          <t-option label="从上到下" value="TB"/>
          <t-option label="从下到上" value="BT"/>
          <t-option label="从左到右" value="LR"/>
          <t-option label="从右到左" value="RL"/>
        </t-select>
      </t-form-item>
    </t-form>
    <t-form label-width="100px" v-if="eleType === 1">
      <t-form-item label="id">
        <t-input v-model="currentEle.id" :disabled="true" size="small"/>
      </t-form-item>
      <t-form-item label="X">
        <t-input-number v-model="currentEle.x" :min="0" :max="2048" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="Y">
        <t-input-number v-model="currentEle.y" :min="0" :max="2048" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="label">
        <t-input v-model="currentEle.label" size="small"/>
      </t-form-item>
      <t-form-item label="label位置">
        <t-select v-model="currentEle.labelCfg.position" @change="changeLabelPosition()" size="small">
          <t-option label="靠左" value="left"/>
          <t-option label="居中" value="center"/>
          <t-option label="靠右" value="right"/>
          <t-option label="顶部" value="top"/>
          <t-option label="底部" value="bottom"/>
        </t-select>
      </t-form-item>
      <t-form-item label="label颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="currentEle.labelCfg.style.fill" size="small"/>
      </t-form-item>
      <t-form-item label="label大小">
        <t-input-number v-model="currentEle.labelCfg.style.fontSize" :min="2" :max="100" size="small"/>
      </t-form-item>

      <t-form-item label="尺寸" v-if="currentEle.type === 'star' || currentEle.type === 'circle' || currentEle.type === 'triangle'">
        <t-input-number v-model="currentEle.size" :min="1" :max="1024" :decimal-places="0" size="small"/>
      </t-form-item>
      <div style="margin-bottom: 10px;" v-else>
        <t-form-item label="尺寸X">
          <t-input-number v-model="currentEle.size[0]" :min="1" :max="1024" :decimal-places="0" size="small"/>
        </t-form-item>
        <t-form-item label="尺寸Y">
          <t-input-number v-model="currentEle.size[1]" :min="1" :max="1024" :decimal-places="0" size="small"/>
        </t-form-item>
      </div>
      <t-form-item label="圆角" v-show="currentEle.type === 'rect'">
        <t-input-number v-model="currentEle.style.radius" :min="0" :max="100" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="填充" v-show="currentEle.type !== 'image'">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="currentEle.style.fill" enableAlpha size="small"/>
      </t-form-item>
      <t-form-item label="描边" v-show="currentEle.type !== 'image'">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="currentEle.style.stroke" size="small"/>
      </t-form-item>
      <t-form-item label="描边宽度" v-show="currentEle.type !== 'image'">
        <t-input-number v-model="currentEle.style.lineWidth" :min="1" :max="100" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="图片" v-if="currentEle.type === 'image'">
        <t-input v-model="currentEle.img" size="small"/>
      </t-form-item>
      <t-button style="margin-top: 10px;" block theme="danger" @click="delCurrentEle()">删除节点</t-button>
    </t-form>
    <t-form label-width="100px" v-if="eleType === 2">
      <t-form-item label="id">
        <t-input v-model="currentEle.id" :disabled="true" size="small"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="currentEle.style.stroke" size="small"/>
      </t-form-item>
      <t-form-item label="线宽度">
        <t-input-number v-model="currentEle.style.lineWidth" :min="1" :max="100" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="虚线">
        <t-input-number v-model="currentEle.style.lineDash[0]" :min="0" :max="20" :decimal-places="0" size="small"/>
      </t-form-item>
      <t-form-item label="label">
        <t-input v-model="currentEle.label" size="small"/>
      </t-form-item>
      <t-form-item label="label位置">
        <t-select v-model="currentEle.labelCfg.position" size="small">
          <t-option label="起始" value="start"/>
          <t-option label="居中" value="middle"/>
          <t-option label="结束" value="end"/>
        </t-select>
      </t-form-item>
      <t-form-item label="label颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="currentEle.labelCfg.style.fill" size="small"/>
      </t-form-item>
      <t-form-item label="label大小">
        <t-input-number v-model="currentEle.labelCfg.style.fontSize" :min="2" :max="100" size="small"/>
      </t-form-item>
<!--      <t-form-item label="箭头显示">
        <t-switch v-model="currentEle.style.endArrow" :label="['开', '关']" size="small"/>
      </t-form-item>-->
      <t-button style="margin-top: 10px;" block theme="danger" @click="delCurrentEle()">删除连线</t-button>
    </t-form>
  </div>
</template>

<script>
export default {
  name: "config-bar-g6",
  watch:{
    currentEle:{
      handler(newObj) {
        if(this.eleType !== 0 && this.render){
          this.$emit('updateItem',newObj);// 渲染图
        }
        this.render = true
      },
      deep: true//深度监听
    },
  },
  data(){
    return {
      formTitle:['画布','节点','连线'],
      currentEle:{},
      eleType:null,
      eleIndex:-1,
      render:true,
    }
  },
  methods:{
    delCurrentEle(){
      this.$emit('delItem',this.eleType,this.eleIndex,this.currentEle);// 渲染图
    },
    showConfig(type,ele,eleIndex){//type:0画布,1节点,2连线
      this.currentEle = ele;
      this.eleType = type;
      this.eleIndex = eleIndex;
      this.render = false;//避免在画布上拖动改变数据执行重新渲染
    },
    changeLabelPosition(){//G6 BUG:https://github.com/antvis/G6/issues/3513
      const position = this.currentEle.labelCfg.position;
      let textAlign = 'center';
      if(position === 'left'){
        textAlign = 'right'
      }else if(position === 'right'){
        textAlign = 'left'
      }
      this.currentEle.labelCfg.style.textAlign = textAlign
    }
  }
}
</script>

<style scoped>
.customForm{padding:10px 6px 0 6px;overflow: auto;}
.cptTitle{line-height: 35px; text-align: center;}
</style>
